import React from "react";

import useDialogs from "hooks/useDialogs";

import Logo from "assets/svg/pm-logo.svg";

const NavRailLead = () => {
  const { showAboutDialog } = useDialogs();
  return (
    <span className="logo" onClick={showAboutDialog}>
      <Logo className="logo-icon" />
    </span>
  );
};

NavRailLead.propType = {};

export default NavRailLead;
